<template>

   <div class="modal fade" id="MissingRankModal" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1">
      <div class="modal-dialog modal-dialog-centered modal-sm">
        <div class="modal-content">
          <button class="btn-close btn-close-menu position-absolute top-0 start-100 translate-middle" type="button" data-bs-dismiss="modal" aria-label="Close">
            <span class="btn-close-icon"></span>
          </button>

          <div class="modal-body p-4">
            <h6 class="mb-4">Vote For Your Area</h6>


              <div class="row gx-2">
                <div class="col-12 col-sm-6">
                  <div class="mb-3">
                    <label for="userSignupFirstName" class="form-label fs-sm fw-bold">Full Name</label>
                    <input type="text" required v-model="fullname" placeholder="Enter First Name" class="form-control shadow-none" id="fullname" />
                  </div>
                </div>
                <!-- /.col-12 -->

                 <div class="col-12 col-sm-6">
                  <div class="mb-3">
                    <label for="userSignupFirstName" class="form-label fs-sm fw-bold">Mobile No</label>
                    <input type="text" required v-model="mobileno" placeholder="Enter Mobile No" class="form-control shadow-none" id="mobileno" />
                  </div>
                </div>
                <!-- /.col-12 -->

                <div class="col-12 col-auto">
                  <div class="mb-3">
                    <label for="userSignupLastName" class="form-label fs-sm fw-bold">Rank Name/Area</label>
                    <input type="text" required v-model="rankname" placeholder="Enter Rank Name" class="form-control shadow-none" id="rankname" />
                  </div>
                </div>
                <!-- /.col-12 -->
              </div>
              <!-- /.row -->

               <div class="mb-3">
                <button type="submit" @click="UpdateCommuter" class="btn btn-primary w-100 text-uppercase fw-bold"
                :disabled="!CanSubmit || this.$wait.is('LoggingIn')"
                >
                 <v-wait for="LoggingIn">
                    <template slot="waiting">
                      <i class="fas fa-spinner fa-spin"></i>
                    </template>
                     Submit
                  </v-wait>
                </button>
              </div>
                 <p class="text-muted">Note: Would you like us to add your nearest taxi rank, Please submit your details and we'll notify you once it has been addded. </p>
                  

            <!-- /.text-center -->
          </div>
          <!-- /.modal-body -->
        </div>
        <!-- /.modal-content -->
      </div>
      <!-- /.modal-dialog modal-dialog-centered modal-sm -->
    </div>
    <!-- /.modal -->

</template>

<script>

import { createNamespacedHelpers } from 'vuex';
const { mapGetters, mapActions } = createNamespacedHelpers('auth');

export default {
	 name: "userSignupModal",
	 props:['AddTaxiOperatorDropDownControl'],
  data: function() {
    return {
      fullname: '',
      mobileno: '',
      rankname: '',
    };
  },
  computed: {
    ...mapGetters(["USERPROFILE","WALLETPROFILE"]),
    CanSubmit: function (){
      return this.fullname != "" && this.mobileno != "" && this.rankname != ""
    },
  },
  components: {
  },
  methods: {
    ...mapActions([
      "RegisterCommuterAction",
      "RequestOTPAction",
      "GetProfile",
    ]),
    isNumber: function(evt) {
      evt = (evt) ? evt : window.event;
      var charCode = (evt.which) ? evt.which : evt.keyCode;
      if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
        evt.preventDefault();;
      } else {
        return true;
      }
    },
    LoadData: function ()
    {
      this.FirstName = this.WALLETPROFILE.firstname;
      this.LastName = this.WALLETPROFILE.surname;
      this.IDNumber = this.WALLETPROFILE.idnumber;
      
    },
    UpdateCommuter: function ()
    {

      if(this.Password != ''){
          if(this.Password.length != 5){
            this.$Notify.Error("Password Must Be 5 Digits", "");
          }
      }

      this.$Notify
        .YesNo(false,true)
        .then((value) => {
          if (value) {
             var context = $(window).data("EditUserModal");
              context.$wait.start("LoggingIn");

              context.$store
              .dispatch("auth/UpdateCommuterAction",{
              firstname:this.FirstName,
              surname:this.LastName,
              mobilenumber:this.Mobile,
              idnumber: this.IDNumber,
              password:this.Password,
              }).then((resutls) => {
              this.$wait.end("LoggingIn");
              if(resutls.Status){
                  this.$store
                .dispatch("auth/GetProfile");
                $('#EditUserModal').modal('hide');
                this.$Notify.Toast("Profile Updated Successfully",true, false);
              } else {
                this.$Notify.Error(resutls.Message, "");
              }
            }).catch(() => {
              this.$wait.end("LoggingIn");
              this.$Notify.Error("Something Went Wrong");
            });
          }
        });


    }
  },
   mounted: function() {

      $(window).data("MissingRankModal",this);

          function ActivatePassword(){
      const togglePassword = document.querySelector("#togglePasswordedit");
      const password = document.querySelector("#passwordsigninedit");

      togglePassword.addEventListener("click", function () {
        
        // toggle the type attribute
        const type = password.getAttribute("type") === "password" ? "text" : "password";
        password.setAttribute("type", type);
        // toggle the eye icon
        this.classList.toggle('fa-eye');
        this.classList.toggle('fa-eye-slash');
      });
    }

    ActivatePassword();

    $(window).data("MissingRankModal",this);

     $('#EditUserModal').on('show.bs.modal', function() {
        // do something when the modal is shown
          var context = $(window).data("MissingRankModal");
          
          debugger;
          //context.GetAllBookings();

          analytics.page("Missing Rank Modal","MissingRankModal");

          context.LoadData()
      });

      
     
  },
}
   
</script>

<style scoped>
.taxissociationbranding
{
  width: 100px;
	position: absolute;
	left: 0;
	right: 0;margin: auto;
}
</style>

